<template>
  <div class="joinUs-page">
    <banner>
      加入我们
    </banner>

    <div class="join-us-container">
      <div class="join-us-info">
        <p class="title-text title-distance">
          我们正在做一件改变中国民生服务方式的事情。在这里，有优秀的领导和有意思的同事，让你发现身边志同道合的人；在这里，小伙伴们都充满活力和激情。欢迎加入我们，和我们一起成长，一起享受工作带来的乐趣，一起做有意思的事情吧~
        </p>
        <ul class="contact-info">
          <li>联系人：张经理</li>
          <li>咨询电话：010-62680078</li>
          <li>咨询邮箱：hr@bjewaytek.com</li>
        </ul>
      </div>
      <div class="job-information">
        <dl class="job-info">
          <dt>
            工作地点：
          </dt>
          <dd>
              <span :class="{'active': (!selected.place)}"
                    @click="togglePlace">不限</span>
            <span v-for="(item) in places"
                  :key="item.id"
                  :class="{'active': item.id === selected.place}"
                  @click="togglePlace(item)">{{item.name}}</span>
          </dd>
        </dl>
        <dl class="job-info">
          <dt>
            招聘职位：
          </dt>
          <dd>
              <span :class="{'active': (!selected.post)}"
                    @click="togglePost">不限</span>
            <span v-for="(item) in posts"
                  :key="item.id"
                  :class="{'active': item.id === selected.post}"
                  @click="togglePost(item)">{{item.name}}</span>
          </dd>
        </dl>
      </div>
      <div class="job-infolist">
        <div class="job-count">
          <h6>共<i>{{jobs.total}}</i>个职位</h6>
          <ul class="recruit-list" v-if="jobs.list.length > 0">
            <li class="no-hover">
              <span class="list-thead"> 职位</span>
              <span class="list-thead">工作地点</span>
              <span class="list-thead">发布时间</span>
            </li>
            <li v-for="(item, index) in jobs.list" @click="showInfo(index)"
                :class="{active: index === detail}"
                :key="index">
              <span> {{item.post}}</span>
              <span>{{item.place}}</span>
              <span>{{item.gmtPublish}}</span>
            </li>
          </ul>
        </div>
        <div class="job-show">
          <div class="job-show-wrap">
            <div class="job-title">
              <h3 class="title-h3 title-h3-distance">
                {{jobs.detail.post}}
              </h3>
              <p class="title-describe">工作地点：<span>{{jobs.detail.place}}</span>
                待遇 <span>{{jobs.detail.salary}}</span></p>
            </div>
            <ul class="jobduty">
              <li class="duty-title">岗位职责</li>
              <li v-html="jobs.detail.responsibility"></li>
            </ul>
            <ul class="jobduty">
              <li class="duty-title">任职资格</li>
              <li v-html="jobs.detail.requirements"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Banner from '../components/Banner.vue';
  import fetch from '../server/index';

  export default {
    data () {
      return {
//        展示筛选条件
        places: [],
        posts: [],
//        选中筛选条件
        selected: {
          place: '',
          post: '',
          pageNumber: 1,
          pageSize: 10
        },
        detail: 0,
        jobs: {
          list: [],
          detail: {},
          total: 0
        }
      }
    },
    watch: {
      selected: {
        deep: true,
        handler () {
          this.getPosts()
        }
      },
      detail () {
        this.getPostDetail()
      }
    },
    methods: {
      showInfo (i) {
        this.detail = i;
      },
      togglePlace (item) {
        this.selected.place = item ? item.id : '';
      },
      togglePost (item) {
        this.selected.post = item ? item.id : '';
      },
      getConditons () {
//        地区获取
        fetch('/api/recruit/places').then(res => {
          this.places = res;
        }, err => {
          console.log(err)
        }).catch(e => {
        })
//        职位获取
        fetch('/api/recruit/posts').then(res => {
          this.posts = res;
        }, err => {
          console.log(err)
        }).catch(e => {
        })
      },
      getPosts () {
//        职位列表筛选结果
        fetch('/api/recruit/list', this.selected).then(res => {
          this.jobs.total = res.total;
          this.jobs.list = res.rows || [];
          this.getPostDetail()
        }, err => {
          console.log(err);
        }).catch(e => {
        })
      },
      getPostDetail () {
        this.jobs.detail = this.jobs.list[this.detail] || {};
      }
    },
    components: {
      Banner
    },
    created () {
      this.getConditons()
      this.getPosts()
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .joinUs-page {
    $theme-color: #00ccff;
    width: 100%;
    height: 100%;
    .pulic-banner-container {
      background-image: url('../assets/images/banners/join-us-banner.jpg');
      .banner-content .banner-txt {
        font-size: 30px;
        line-height: 1.5em;
      }
    }
    .join-us-container {
      width: 100%;
      background: #f4f4f4;
      .join-us-info {
        @include public_content();
        padding: 96px 20px 86px 20px;
        .title-center {
          text-align: center;
          line-height: 50px;
        }
        .title-distance {
          font-size: 14px;
          color: #3b3b3b;
          padding-left: 22px;
          padding-right: 22px;
          text-align: center;
          margin-bottom: 90px;
        }
        .contact-info {
          display: flex;
          justify-content: center;
          align-items: center;
          li {
            color: #858585;
            padding: 0 30px;
            line-height: 24px;
            background: url('../assets/images/i-man.png') no-repeat left center;
            background-position: 10px center;
            &:nth-child(2) {
              background-image: url('../assets/images/i-concat.png');
              background-position: 4px center;
            }
            &:nth-child(3) {
              background-image: url('../assets/images/i-email.png');
              background-position: left center;
            }
            &:last-child{
              padding-right: 0;
            }
          }
        }
      }
      .job-information {
        width: 100%;
        @include public_content();
        padding: 0 20px;
        .job-info {
          display: flex;
          margin-bottom: 22px;
          line-height: 28px;
          dd {
            span {
              display: inline-block;
              padding: 0 16px;
              border-radius: 3px;
              margin-right: 12px;
              color: #3b3b3b;
              cursor: pointer;
              font-size: 16px;
              &:last-child{
                margin-right: 0;
              }
              &:hover,
              &.active {
                background: $theme-color;
                color: #fff;
                font-weight: bold;
              }
            }
          }
          dt {
            font-size: 16px;
            font-weight: bold;
            color: #3b3b3b;
          }
        }
      }
      .job-infolist {
        @include public_content();
        display: flex;
        margin-top: 35px;
        padding-bottom: 60px;
        // box-shadow: -2px 0px 2px #e5e5e7;
        .job-count, .job-show {
          border: 1px solid #e5e5e7;
          background: #fff;
          border-radius: 5px;
        }
        .job-count {
          width: 690px;
          margin-right: 7px;
          h6 {
            line-height: 1em;
            padding: 25px;
            i {
              color: $theme-color;
              font-weight: 800;
              padding: 0 10px;
            }
          }
          .recruit-list {
            li {
              display: flex;
              width: 100%;
              justify-content: space-between;
              padding: 0 10px;
              line-height: 40px;
              text-align: center;
              cursor: pointer;
              &:hover,
              &.active {
                background: #f3f3f3;
              }
              &.no-hover:hover {
                background: inherit;
              }
              span {
                color: #3b3b3b;
                width: 33.3%;
                font-size: 14px;
                line-height: 42px;
              }
              .list-thead {
                font-weight: 600;
                font-size: 14px;
                color: #3b3b3b;
                height: 52px;
                line-height:48px;
              }
            }
          }
        }
        .job-show {
          width: 450px;
          margin-left: 7px;
          padding-bottom: 50px;
          .job-title {
            padding: 20px;
            .title-h3-distance {
              color: #3b3b3b;
            }
            .title-describe {
              border-bottom: 1px solid #e5e5e7;
              line-height: 55px;
              color: #646464;
              *{
                font-size: inherit;
              }
            }
          }
          .jobduty {
            padding: 10px 20px;
            color: #646464;
            font-size: 14px;
            li {
              line-height: 30px;
              font-size: 14px;
              color: #3b3b3b;
              p{
                font-size: inherit;
                color: inherit;
              }
            }
            .duty-title {
              font-weight: 600;
              font-size: 14px;
              line-height: 30px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pc/JoinUs.vue